// extracted by mini-css-extract-plugin
module.exports = {"content":"rulings_content__ioEtO","ruling":"rulings_ruling__4zzlV","comment":"rulings_comment__LFyNH","date":"rulings_date__2uWeM","noRulings":"rulings_noRulings__GsqsU"};